import WIDGETS from './widgets';

export default {
	name: 'admin_client_management',
	spacing: 2,
	widgets: [
		{ content: WIDGETS.CLIENT_MANAGEMENT, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
    { content: WIDGETS.SERVICES, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },  
		{ content: WIDGETS.USER_MANAGEMENT, breakpoints: { xs: 12, md: 12 }, lazy_loading: 0 },
	],
};
